import { type ReactNode, useEffect } from "react";

import { useLocalStorage } from "@honeycomb/mystique";

const UiTheme = (props: { children?: ReactNode }) => {
  const [uiTheme] = useLocalStorage<string>({
    key: "uiTheme",
    defaultValue: "classic",
    onExternalUpdate: () => {
      window.location.reload();
    },
  });

  useEffect(() => {
    switch (uiTheme) {
      case "mars":
        import("@app/styles/branding/mars.css");
        break;
    }

    document.body.dataset.uiTheme = uiTheme;
  }, [uiTheme]);

  return <>{props.children}</>;
};
UiTheme.displayName = "UiTheme";

export { UiTheme };
